import React from 'react'
import logo from "../images/logo.png";
import image3 from "../images/image3.png";
import image2 from "../images/image2.png";
import image10 from "../images/image10.png";
import image11 from "../images/image11.png";
import image12 from "../images/image12.png";
import image8 from "../images/image8.png";
import DragImage2 from "../images/DragImage2.png";
import { IoIosArrowBack } from "react-icons/io";
import Footer from "../component/Footer"

function Blog2() {
  const style = { color: "#ABAEC1", width: "184px", height: "52px" }

  return (
    <>

      <div className="Blog-container">

        <div className="LogoH1-Container">
          <div className="Back-Container">
            <a className="blog-back1" href="./" > < IoIosArrowBack />Back</a>
            <img className="" src={DragImage2} alt="" />
          </div>

          <div className="Logo2H1-Container">
            <img className="logo2" src={logo} style={style} alt='logo-image' />
            <h1 className="Blog-H">Learn the art of business management</h1>
          </div>
        </div>


        <div className="blog-main-container">
          <div className="Session1-container">

            <div className="image1-container">
              <img className="blog-image1" src={image3} alt="" />
              <div className="Para-ReadMore-Con">
                <p className="Blog2-p1">How to Create A Business Plan</p>
                <a href="#" className="readmore1">Read More</a>
              </div>
            </div>

            <div className="image2-container">
              <img className="blog-image2" src={image2} alt="" />
              <div className="Para-ReadMore-Con">
                <p className="Blog2-p2">Understanding and managing Business Risks</p>
                <a href="#" className="readmore2">Read More</a>
              </div>
            </div>
          </div>

          <div className="Session2-container">
            <div className="image3-container">
              <img className="blog-image3" src={image8} alt="" />
              <div className="Para-ReadMore-Con">
                <p className="Blog2-p3"> Understanding and managing Cashflow</p>
                <a href="#" className="readmore3">Read More</a>
              </div>
            </div>

            <div className="image4-container">
              <img className="blog-image4" src={image10} alt="" />
              <div className="Para-ReadMore-Con">
                <p className="Blog2-p4"> Effective Communication Strategies for Small Businesses</p>
                <a href="#" className="readmore4">Read More</a>
              </div>
            </div>
          </div>

          <div className="Session3-container">
            <div className="image5-container">
              <img className="blog-image5" src={image11} alt="" />
              <div className="Para-ReadMore-Con">
                <p className="Blog2-p5">Entrepreneurship and the mindset of a successful business  owner</p>
                <a href="#" className="readmore5">Read More</a>
              </div>
            </div>

            <div className="image6-container">
              <img className="blog-image6" src={image12} alt="" />
              <div className="Para-ReadMore-Con">
                <p className="Blog2-p6">Managing Inventory and Supply Chain Management</p>
                <a href="#" className="readmore6">Read More</a>
              </div>
            </div>
          </div>
          <div className="Pagination-Container">
            <button className="btn-num1"><a href="./blog" className="num1">1</a></button>
            <button className="btn-num2"><a href="./blog2" className="num2">2</a></button>
          </div>
        </div>
      </div >

      <Footer />
    </>
  );
}

export default Blog2
